module.exports = __webpack_public_path__ + "static/img/certificate1.d8710a44.png";